module.exports = __webpack_public_path__ + "img/search-light.d47a56f0.svg";